export default "__VITE_PUBLIC_ASSET__c559edf6__"